export default function MeetingDetailsSkeleton() {
  return (
    <div className="animate-pulse">
      <div className="sm:px-0">
        <div className="h-6 w-1/3 bg-gray-300 rounded mb-2"></div>
        <div className="h-4 w-2/3 bg-gray-300 rounded mb-2"></div>
        <div className="h-4 w-1/2 bg-gray-300 rounded mb-2"></div>
        <div className="h-4 w-1/3 bg-gray-300 rounded"></div>
      </div>
      <div className="mt-6 border-t border-b border-gray-900/10"></div>
      <dl className="divide-y divide-gray-900/10">
        <div className="py-6">
          <div className="h-6 w-1/3 bg-gray-300 rounded mb-2"></div>
          <div className="h-4 w-2/3 bg-gray-300 rounded mb-4"></div>
          <div className="mt-6 space-y-3 max-w-xl">
            <div
              className="grid grid-cols-3 gap-4 items-center min-h-6"
              aria-hidden="true">
              <div className="h-4 w-2/3 bg-gray-300 rounded"></div>
              <div className="h-4 w-4 bg-gray-300 rounded-full"></div>
            </div>
            <div className="grid grid-cols-3 gap-4 items-center min-h-6">
              <div className="h-4 w-2/3 bg-gray-300 rounded"></div>
              <div className="h-4 w-4 bg-gray-300 rounded-full"></div>
            </div>
            <div className="grid grid-cols-3 gap-4 items-center min-h-6">
              <div className="h-4 w-2/3 bg-gray-300 rounded"></div>
              <div className="h-4 w-4 bg-gray-300 rounded-full"></div>
            </div>
            <div className="grid grid-cols-3 gap-4 items-center min-h-6">
              <div className="h-4 w-2/3 bg-gray-300 rounded"></div>
              <div className="h-4 w-4 bg-gray-300 rounded-full"></div>
            </div>
          </div>
        </div>
        <div className="py-6">
          <div className="h-6 w-1/3 bg-gray-300 rounded mb-2"></div>
          <div className="h-4 w-2/3 bg-gray-300 rounded mb-4"></div>
        </div>
      </dl>
      <div className="flex justify-center mt-6">
        <div className="h-10 w-24 bg-gray-300 rounded mr-6"></div>
        <div className="h-10 w-24 bg-gray-300 rounded opacity-50"></div>
      </div>
    </div>
  )
}
